import React from 'react'
import CampaignCreateForm from '../../forms/CampaignCreateForm'

function CampaignAdminCreate() {
  return (
    <div>
      <CampaignCreateForm />
    </div>
  )
}

export default CampaignAdminCreate